export default __webpack_public_path__ + "static/media/ceramol-iage-map-background.b59dfc21.png";